<template>
  <section class="content padded">
    <h2 class="align-center">Choose your truck</h2>
    <div class="brands">
      <div class="brand brand-freightliner">
        <a href="https://freightliner.com/" target="_blank">
          <div class="bg"></div>
          <div class="logo-wrap">
            <img class="brand-logo" src="../assets/img/FL-Logo-02.png"/>
          </div>
        </a>
      </div>
      <div class="brand brand-westernstar">
        <a href="https://www.westernstartrucks.com/" target="_blank">
          <div class="bg"></div>
          <div class="logo-wrap">
            <img class="brand-logo" src="../assets/img/Western-Star-Logo.png"/>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name:'HomeBrands',
    data(){
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/HomeBrands.vue